import { transition } from '@helpers/animate';
import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  --bgColor: ${brand.green};
  --fgColor: ${brand.white};
  --itemGap: 8px;
  --itemPadding: 8px;
  --itemSize: 24px;

  color: var(--fgColor);
  margin-top: 3rem;
  margin-bottom: 0;
  display: flex;
  align-items: center;

  @media ${from(Device.MobileLarge)} {
    --itemPadding: 12px;
  }
`;
const Text = styled.span `
  display: inline-block;
  ${fonts.montserrat.bold};
  font-size: 16px;
  line-height: 32px;
  padding-right: 8px;

  @media ${from(Device.TabletLarge)} {
    padding-right: 10px;
  }
`;
const List = styled.ul `
  display: flex;
  align-items: center;
  gap: var(--itemGap);
`;
const Item = styled.li ``;
const Link = styled.a `
  ${transition('transform, opacity')};

  display: block;
  background-color: transparent;
  border: 0;
  border-radius: 50%;
  color: currentColor;
  margin: 0;
  padding: var(--itemPadding);
  text-decoration: none;
  transform: scale(1);

  /* Enable focus styles for Safari */
  &:focus {
    outline: auto;
    outline-color: var(--bgColor);
    outline-offset: 5px;
    outline-width: thin;
  }

  /* Disable default focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: auto;
    outline-color: var(--bgColor);
    outline-offset: 5px;
    outline-width: thin;
  }

  /* Apply hover styles */
  &:hover {
    transform: scale(1.2);
  }

  &:disabled {
    opacity: 0.33;
  }
`;
const Icon = styled.span `
  display: block;
  height: var(--itemSize);
  color: currentColor;
  width: var(--itemSize);
`;
const ShareButtonsStyles = {
    Container,
    Icon,
    Item,
    Link,
    List,
    Text,
};
export default ShareButtonsStyles;
